import { render, staticRenderFns } from "./pay-2.vue?vue&type=template&id=37e9fa8c&scoped=true&"
import script from "./pay-2.vue?vue&type=script&lang=js&"
export * from "./pay-2.vue?vue&type=script&lang=js&"
import style0 from "./pay-2.vue?vue&type=style&index=0&id=37e9fa8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9fa8c",
  null
  
)

export default component.exports